import { BasicSelect, MultiSelect } from 'vue-search-select'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';
import CryptoJS from 'crypto-js'
import Pagination from './../../../shared/components/pagination'
import CustomExpandableTable from '../../../shared/components/customExpandableTable'
import Loader from '../../../shared/components/loader'
import CONSTANT from '../../../shared/constants/constant'
import Util from '../../../shared/util/util'
import Treeselect from '@riophae/vue-treeselect'
import TripServices from '../../services/firstAndLastmilemanagement.service'
import ClientService from '../../../clientmanagement/services/clientmanagement.service';
import CreateBoxTypeconfig from './CreateBoxTypeconfig';
import MasterService from './../../../masterdata/services/masterdata.service';

import XLSX from 'xlsx'
const moment = require('moment')

export default {
  name: 'boxtypeconfig',
  components: {
    Treeselect,
    CryptoJS,
    Pagination,
    BasicSelect,
    CustomExpandableTable,
    Loader,
    CreateBoxTypeconfig,
    Multiselect,
  },
  data: function () {
    return {
      createFTCCashDeposit: false,
      isLoading: false,
      companyNamelist: [],
      tableColumn: [
        "Client Name",
        "Box Type",
        "Dimensions (cm)",
        "Created By",
        "Created Date",
        "Last Modified By",
        "Last Modified Date",
        "Status",
        "Action",
      ],
      tableItems: [],
      tableData:[],
      selectedBoxType: null,
      boxtypelist: [],
      totalPage: 0,
      currentPage: 1,
      total: 0,
      totalCount: 0,
      perPage: 0,
      pageLimit: CONSTANT.PER_PAGE_DATA,
      offset: 0,
      AWB: "",
      Action: "",
      showCreateBoxTypeConfig:false,
      useremail: "",
      Clientlist:[],
      parentData:{},
      selectedClient: null,
    };
  },
  computed: {},
  async mounted () {
    var userdetailEncrypt = window.localStorage.getItem(
      'cargoAutoaccessuserdata'
    )
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key')
    var plaintext = bytes.toString(CryptoJS.enc.Utf8)
    var userdetail = JSON.parse(plaintext)
    this.hubid = userdetail.hubID[0];
    this.localuserid = userdetail.userid;
    this.useremail = userdetail.email
    this.isLoading = true;
    await Promise.all([
      this.getConfig(),
      this.getBoxTypeList(),
      this.getCompanyShortName()
    ]) 
    this.isLoading = false;
  },
  methods: {
    search(){
      this.currentPage = 1;
      this.offset = 0;
      if ((this.selectedClient && this.selectedClient.value) || (this.selectedBoxType && this.selectedBoxType.value)) {
        this.getConfig();
      } else {
        this.$alert("Please select Client Name or Box Type.", "", "error");
      }
    },
    async getConfig () {
      try {
        this.isLoading = true
        this.tableItems = [];
        let input = {
          "offset": this.offset,
          "limit": this.pageLimit
        }
        if (this.selectedClient && this.selectedClient.value) {
          input.clientid = this.selectedClient.value
        }
        if (this.selectedBoxType && this.selectedBoxType.value) {
          input.boxtypeid = this.selectedBoxType.value;
        } 
        let result = await ClientService.getClientBoxTypeMapping(input);
        if (result.data.code == 200) {
          this.totalCount = result.data.data.count
          this.tableData = result.data.data.rows;
          let tempData = result.data.data.rows.map(el => {
            let dimension = "L: , B: , H: "
            if (el['boxtypemaster.dimensions']) {
              dimension = `L:${el['boxtypemaster.dimensions'].L}, B:${el['boxtypemaster.dimensions'].B}, H:${el['boxtypemaster.dimensions'].H} `;
            }
            let responseObj = {
              'id': el.id,
              'Client Name': el.clientname,
              'Box Type': el['boxtypemaster.boxtype'],
              'Dimensions (cm)': dimension,
              'Created By': el.createdby,
              'Created Date': Util.displayDateTimeFormat(el.createddate),
              'Last Modified By': el.lastmodifiedby,
              'Last Modified Date': Util.displayDateTimeFormat(el.lastmodifieddate),
              "Status": el.status,
            }
            return responseObj;
          })
          this.tableItems = tempData;
        } else {
          this.totalCount = 0;
          this.tableItems = [];
        }
        if (this.totalCount < this.pageLimit) {
          this.totalPage = 1
        } else {
          this.totalPage = Math.ceil(this.totalCount / this.pageLimit);
        }
        this.isLoading = false
      } catch (err) {
        console.log(err)
        this.isLoading = false
      }
    },
    selectHub(data){
      this.selectedBoxType = data;
      this.originSearch = data.value;
    },
    selectClient(data){
      this.selectedClient = data;
    },
    async getBoxTypeList() {
      try {
        this.isLoading = true;
        let InputPayload = {};
        let result = await MasterService.getAllBoxTypes(InputPayload);
        let tempBoxtypes = result.data.data;
        let boxtype = [];
        for (var i = 0; i < tempBoxtypes.length; i++) {
          let isdisabled = false;
          if(tempBoxtypes[i].status==0){
            isdisabled = true;
          }else{
            boxtype.push(tempBoxtypes[i]);
          }
          this.boxtypelist.push({
            'value': tempBoxtypes[i].id,
            'text': tempBoxtypes[i].boxtype,
            'id': tempBoxtypes[i].id,
            'label': tempBoxtypes[i].boxtype,
            'isDisabled': isdisabled
          })
        }
        this.isLoading = false;
      } catch (err) {
        console.log(err)
      }
    },
    onPageChange(page){
      this.currentPage = page;
      this.offset = (page - 1) * this.pageLimit
      this.getConfig();
    },
    showBoxTypeConfiguration(type,data) {
      this.showCreateBoxTypeConfig = true;
      this.parentData = {
        boxtypelist: this.boxtypelist,
        clientlist : this.Clientlist,
        action: type,
        useremail: this.useremail
      }
      if (type== 'update') {
        let obj = this.tableData.find(o => o.id === data.id);
        this.parentData.data = obj
      }
    },
    getCustomTableEvent(event) {
      if (event.actionType == 'edit') {
        this.showBoxTypeConfiguration('update', event)
      } else {
        this.$confirm("Are you sure to make Active/Inactive?","","question").then(() => {
          this.updatestatus(event);
        }).catch((err)=>{
          console.log(err)
        });
      }
    },
    async updatestatus(input) {
      try {
        let payload = {
          id : input.id,
          type:'CLIENT_BOX_TYPE_MAPPING',
        }
        if (input.actionType == 'active') {
          payload.status = 0
        } else if (input.actionType == 'inactive') {
          payload.status = 1
        }
        let result = await ClientService.changeStatus(payload);
        if(result.data.code == 200) {
          this.getConfig()
          let message = input.actionType == 'inactive' ? "Configuration Activated": "Configuration Inactivated";
          this.$alert(message, "", "success");
        } else{
          this.$alert(result.data.message, "", "error");
        }
      } catch (error) {
        this.$alert("Boxtype mapping already Active/Inactive.", "", "error");
      }
    },
    async getCompanyShortName(){
      try {
        let InputPayload = {};
        var CompanyShortList = [];
        let result = await ClientService.GetClientListByActiveContracts(InputPayload)
        CompanyShortList = result.data.data.rows;
        for (var i = 0; i < CompanyShortList.length; i++) {
          this.Clientlist.push({
            'value': CompanyShortList[i].clientid,
            'text': CompanyShortList[i].clientshortname,
            'id' : CompanyShortList[i].clientbusinessaccountid,
          })
        }
      } catch(err){
        console.log(err);
      }
    },
    callParent(data) {
      this.getConfig()
      this.showCreateBoxTypeConfig = false;
      this.parentData = {}
    },
    resetFilter() {
      this.selectedClient = null
      this.selectedBoxType = null;
      this.onPageChange(1)
    },
  }
}



// WEBPACK FOOTER //
// ./src/modules/firstAndLastmilemanagement/views/boxtypeconfig/boxtypeconfig.component.js